export const scorecardRoutes = [
    {
        path: '/scorecard-v2',
        name: 'Scorecard',
        meta: {
            requiresAuth: true,
            accessId: 'scorecard',
        },
        component: () =>
            import ('../views/Scorecard.vue')
    },
    {
        path: '/scorecard-v2/:subjectId',
        name: 'scorecard-details',
        meta: {
            requiresAuth: true,
            accessId: 'scorecard',
        },
        component: () =>
            import ('../views/Details.vue')
    },
]